/* eslint-disable */ 
import {StyleSheet, Dimensions} from 'react-native';

const {width, height} = Dimensions.get('screen');
export const styles = StyleSheet.create({
  container: {
    marginLeft:20
  },
});